import { render, staticRenderFns } from "./PeiXun.vue?vue&type=template&id=91d6f0aa&scoped=true&"
import script from "./PeiXun.vue?vue&type=script&lang=js&"
export * from "./PeiXun.vue?vue&type=script&lang=js&"
import style0 from "./PeiXun.vue?vue&type=style&index=0&id=91d6f0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d6f0aa",
  null
  
)

export default component.exports